import type { HelpFile } from '../../types/help'
import { PaginationTestIds } from '../../../testids/PaginationTestIds'

export const paginationHelp: HelpFile = {
  docPage: '/docs/help-system/pagination',
  texts: {
    [PaginationTestIds.btnFirstPage]: null,
    [PaginationTestIds.btnLastPage]: null,
    [PaginationTestIds.btnNextPage]: null,
    [PaginationTestIds.btnPreviousPage]: null,
    [PaginationTestIds.paginationInfo]:
      'Zeigt den aktuellen Seitenbereich und die Gesamttrefferzahl — mit den Pfeilen durch die Seiten navigieren oder die Seitengröße anpassen, um mehr Zeilen auf einmal zu laden.',
    [PaginationTestIds.paginationPageInfo]: null,
    [PaginationTestIds.selectPageSize]: null,
  },
}
